import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import portrait from '../img/profile-2026.png';

function HomePage() {
    return (
        <div className="HomePage">
            <header className="hero">
                <div className="hero-copy">
                    <h1 className="hero-text">
                        Building the future of financial education.
                    </h1>
                    <p className="h-sub-text">
                        I am Barbara Sanchez, co-founder and CTO of GM. I build financial education products that combine
                        frontend development, market data, quantitative trading, and agentic AI to make investing
                        easier to understand.
                    </p>
                    <div className="hero-actions">
                        <a className="btn primary" href="#projects">Explore work</a>
                    </div>
                    <div className="icons">
                        <a href="https://github.com/babettsan" className="icon-holder" aria-label="GitHub">
                            <FontAwesomeIcon icon={faGithub} className="icon gh" />
                        </a>
                        <a href="https://www.linkedin.com/in/babettsan" className="icon-holder" aria-label="LinkedIn">
                            <FontAwesomeIcon icon={faLinkedinIn} className="icon in" />
                        </a>
                        <a href="mailto:babettsan@gmail.com" className="icon-holder" aria-label="Email">
                            <FontAwesomeIcon icon={faEnvelope} className="icon mail" />
                        </a>
                    </div>
                </div>

                <div className="hero-visual" aria-label="Portrait inspired profile artwork">
                    <div className="portrait-frame">
                        <img src={portrait} alt="Barbara Sanchez portrait" />
                    </div>
                    <div className="hero-card card-primary">
                        <span>Mission</span>
                        <strong>Financial education for more people</strong>
                    </div>
                    <div className="hero-card card-secondary">
                        <span>Work</span>
                        <strong>Founder-led tools for investors and learners</strong>
                    </div>
                </div>
            </header>

        </div>
    )
}
export default HomePage;
